<template>
    <div class="networkErrorWrapper" >
        <div class="networkError">
            <unicon name="wifi-slash" />
            <label v-if="!retryingConnection">Disconected! <a href="#" @click.prevent="reTry">Retry...</a></label>
            <label v-else><b-spinner variant="primary" class="retryingLoader" type="grow"></b-spinner></label>
            <label class="mt-4"><a href="#" @click.prevent="leaveRoom">Leave Room</a></label>
        </div>
    </div>
</template>
<script>
import Server from "@/server";
import store from "@/store";
export default {
    methods:{
        reTry(){
            Server.reTry();
        },
        leaveRoom(){
            Server.leaveRoom();
        }
    },computed:{
        retryingConnection:()=>store.state.room.retryingConnection
    }
}
</script>